import React, {useEffect, useState} from "react";
import "./style.scss"
import IconButton from "../IconButton";
import {useTranslation} from "react-i18next";

export const CopyToClipboard = ({onClick, icon, tooltip, dataForClipboard, text}) => {
    const {t} = useTranslation();

    const [isShowLabel, setShowLabel] = useState(false);

    useEffect(() => {
        if(isShowLabel) {
            setTimeout(() => {
                setShowLabel(false);
            }, 1000);
        }
    }, [isShowLabel]);

    const onClickCopy = () => {
        setShowLabel(true);

        if(onClick) {
            onClick();
            return;
        }

        let textField = document.createElement("textarea");
        textField.innerText = dataForClipboard;
        document.body.appendChild(textField);
        textField.select();
        document.execCommand("copy");
        textField.remove();
    }

    return (
        <div className={"copyToClipboard"}>
            {text && <span onClick={onClickCopy}>{text}</span>}
            {icon && (
                <IconButton isIcon iconName={icon} onClick={onClickCopy} tooltipText={tooltip}/>
            )}
            {isShowLabel && (
                <div className={"labelCopied"}>{t("settings.map.DEPOT_LINK_COPIED")}</div>
            )}
        </div>
    )
};